module.exports = cptable;